import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import { ListItem, Tooltip, ListItemButton, ListItemIcon, ListItemText } from '@unity/cloud-ui';
import { useTranslations } from 'next-intl';
import { NavigationLink } from '../navigation-link';

export type AdditionalResourcesItem = {
  title: string;
  href: string;
};

export function AdditionalResourcesItem(props: { item: AdditionalResourcesItem }) {
  const t = useTranslations();

  return (
    <ListItem
      key={props.item.href}
      sx={{
        width: 'auto',
        p: 0,
        ml: 1,
      }}
    >
      <Tooltip title={props.item.title} enterDelay={800} placement="auto">
        <ListItemButton
          href={props.item.href}
          component={NavigationLink}
          target="_blank"
          aria-label={t('accessibility:open-in-new-tab', { title: props.item.title })}
          sx={{
            py: 0.5,
            px: 1,
            gap: 1,
          }}
        >
          <ListItemIcon color="text.primary">
            <ArrowSquareOutIcon aria-label={t('accessibility:icon:external-link')} />
          </ListItemIcon>
          <ListItemText
            primary={props.item.title}
            sx={{
              m: 0,
            }}
            slotProps={{
              primary: {
                sx: {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              },
            }}
          />
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}
